import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { useContext } from 'react';

import Context from '../context';
import { ActionTypes } from '../types/types';
import { Resources } from './resources';

interface ActionSizeContainerProps {
    hidden: boolean;
}

export const ActionSizeContainer = (props: ActionSizeContainerProps) => {
    const { state, dispatch } = useContext(Context);

    const changeSelectAllChecked = (_: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
        const action = {
            type: ActionTypes.SELECT_ALL_ACTIONS_WITH_LARGE_PAYLOAD_CLICKED,
            payload: !!checked
        };
        dispatch(action);
    }

    const isChecked = (): boolean => {
        return state.isSelectAllActionsWithLargePayloadChecked;
    }

    return (
        <div className="calc-action-size-container" hidden={props.hidden}>
            <Label className="calc-action-size-container-label">{Resources.HAS_LARGE_ACTIONS_LABEL}</Label>
            {state.workflowActions.length > 0
            ? <div className="calc-action-list">
                <div className="calc-action-select-all" key="selectall">
                    <Checkbox
                        aria-label="Select All Checkbox"
                        className="calc-action-size-checkbox"
                        onChange={changeSelectAllChecked}
                        checked={isChecked()}
                    />  
                    <Label className="calc-action-size-label">{Resources.SELECT_ALL_TEXT}</Label>
                </div>
                { state.workflowActions.map(action => (
                    <ActionSize actionName={action} /> ))
                }
            </div>
            : undefined
            }
        </div>
    );
}

interface ActionSizeProps {
    actionName: string;
}

export const ActionSize = (props: ActionSizeProps) => {
    const { state, dispatch } = useContext(Context);

    const changeActionChecked = (_: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
        const action = {
            type: ActionTypes.UPDATE_ACTIONS_WITH_LARGE_PAYLOADS,
            payload: { action: props.actionName, toAdd: !!checked }
        };
        dispatch(action);
    }

    const isActionChecked = (): boolean => {
        const actionsChecked = state.allActionsWithLargePayload;
        return actionsChecked.indexOf(props.actionName) !== -1;
    }

    return(
        <div className="calc-action-size" key={props.actionName}>
            <Checkbox
                aria-label={`${props.actionName} checkbox`}
                className="calc-action-size-checkbox"
                onChange={changeActionChecked}
                checked={isActionChecked()}
            />  
            <Label className="calc-action-size-label">{props.actionName}</Label>
        </div>      
    );
}
